import { render } from "./PerformanceChannel.vue?vue&type=template&id=747c833b"
import script from "./PerformanceChannel.vue?vue&type=script&lang=js"
export * from "./PerformanceChannel.vue?vue&type=script&lang=js"

import "./PerformanceChannel.vue?vue&type=style&index=0&id=747c833b&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__